module.exports = __webpack_public_path__ + "img/news-1.fb831de6.jpg";